module.exports = __webpack_public_path__ + "static/timi-20a2090803e6d1b173a80494a4c1d0e3.jpg";